import { hydrateRoot } from 'react-dom/client'
import './fonts/base.css'
import './index.css'
import Root from './Root'
import { preloadPage } from './App'
import { createI18n, type LocaleFiles, type TranslationFile } from './i18n'
import type { AltMap } from './i18n/alt'
import { splitLocale } from './i18n/locales'

// Translations are split per locale so English pages never download them.
const uiFiles = import.meta.glob<TranslationFile>('../locales/*/ui.json', { import: 'default' })
const contentFiles = import.meta.glob<TranslationFile>('../locales/*/content.json', { import: 'default' })
// Noto Sans SC / Tamil: only on their locales (the prerendered HTML also links the stylesheet, so this is a no-op then).
const fontCss = import.meta.glob('./fonts/*.css')

async function start() {
  const { locale, path } = splitLocale(window.location.pathname)
  const page = preloadPage(path) // fetch this page's chunk in parallel with the locale strings
  const files: LocaleFiles = {}
  fontCss[`./fonts/${locale}.css`]?.()
  if (locale !== 'en') {
    const [ui, content] = await Promise.all([uiFiles[`../locales/${locale}/ui.json`]?.(), contentFiles[`../locales/${locale}/content.json`]?.()])
    Object.assign(files, { ui, content })
  }
  // The same availability map the prerenderer used, embedded in the page, so the first render matches the HTML.
  let alt: AltMap = {}
  try { alt = JSON.parse(document.getElementById('alt-map')?.textContent || '{}') } catch { /* keep empty */ }
  // Every page is prerendered at build time (scripts/prerender.mjs); the client hydrates that HTML instead of re-rendering it.
  await page
  hydrateRoot(document.getElementById('root')!, <Root i18n={createI18n(locale, files)} alt={alt} />)
}
start()
